import React from "react";

/**
 * Three-(or-N-)dot progress motif (E §8): referral-submit success screen,
 * pipeline glance. steps: [{ label, done }]. Purely presentational.
 */
function MiniTimeline({ steps }) {
  return (
    <div className="fk-minitimeline">
      {steps.map((step, i) => (
        <React.Fragment key={step.label}>
          {i > 0 ? <span className="fk-minitimeline__line" /> : null}
          <span className="fk-minitimeline__step">
            <span
              className={`fk-minitimeline__dot${step.done ? " fk-minitimeline__dot--done" : ""}`}
            />
            <span className="fk-minitimeline__label">{step.label}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

export default MiniTimeline;
